"use client";

import React from "react";

import Typography from "@/components/flowbite/typography/typography";
import { ArrowRightIcon } from "@/components/icons-lib";

import { SectionTitle } from "../section-title";

export interface ClusterSelectionListItem {
  id: string;
  name: string;
}

interface ClusterSelectionListProps {
  sectionTitle: string;
  columnHeader?: string;
  items: ClusterSelectionListItem[];
  onItemSelect: (id: string) => void;
  renderTrailing?: (item: ClusterSelectionListItem) => React.ReactNode;
}

const ClusterSelectionListComponent: React.FC<ClusterSelectionListProps> = ({
  sectionTitle,
  columnHeader,
  items,
  onItemSelect,
  renderTrailing,
}) => {
  if (!items.length) return null;

  return (
    <div>
      <SectionTitle title={sectionTitle} />

      <div className="mt-2">
        {columnHeader ? (
          <Typography.BodySRegular
            className="pb-2 uppercase text-gray-400"
            colorShade={400}
          >
            {columnHeader}
          </Typography.BodySRegular>
        ) : null}

        {items.map((item) => (
          <button
            key={item.id}
            aria-label={`Open ${item.name}`}
            className="flex w-full min-w-0 cursor-pointer items-center gap-2 border-b border-gray-200 py-2.5 text-left transition-colors hover:bg-gray-50"
            type="button"
            onClick={() => onItemSelect(item.id)}
          >
            <Typography.BodyMRegular
              className="min-w-0 flex-1 truncate text-darkRed-700"
              colorShade={500}
            >
              {item.name}
            </Typography.BodyMRegular>

            {renderTrailing?.(item)}

            <span
              aria-hidden
              className="flex h-8 w-8 shrink-0 items-center justify-center text-darkRed-700"
            >
              <ArrowRightIcon className="h-5 w-5 shrink-0 stroke-darkRed-700 text-darkRed-700" />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export const ClusterSelectionList = React.memo(ClusterSelectionListComponent);
